import React from "react";
import "../Style/categories.css";
 
  import kachha_bella1 from '../assets/image/product/1.webp'
 import Shagun_Premium1 from '../assets/image/product/2.webp'
 import madhuban1 from '../assets/image/product/3.webp'
import dhoop1 from '../assets/image/product/dhoop1.webp'
import dhoop5 from '../assets/image/product/dhoop5.webp'

const categories = [
  { id: 1, image: kachha_bella1, title: "kachha bella Premium " },
  { id: 2, image: Shagun_Premium1, title: "Shagun Premium" },
  { id: 3, image: madhuban1, title: "madhuban Premium " },
  { id: 4, image: dhoop1, title: "  LUXE Premium Dhoop" },
  { id: 5, image: dhoop5, title: "  LUXE Premium Dhoop" },
  
];

const Categories = () => {
  return (
    <section className="category-section">
       

      <div className="category-container">
        {categories.map((cat) => (
          <div className="category-box" key={cat.id}>
            <img src={cat.image} alt={cat.title} className="category-img" />
            <p className="category-name">{cat.title}</p>
          </div>
        ))}
      </div>
    </section>
  );
};

export default Categories;
